import { refreshTokenV2 } from "./ejm-api.js"
import { clearSession } from "../session/session.js"
import { go } from "../router/router-mixin.js"
import routes from "../router/routes.js"

const DEFAULT_API = process.env.API_URL

/** @type {HttpMethods} */
export const Methods = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
}

/**
 * @param {string} path
 * @param {ApiFetchOptions} method
 * @param {Object | FormData} [body]
 * @returns {Promise<Response>}
 */
export async function apiFetch(path, method, body = null, contentType = 'application/json') {
  const API = DEFAULT_API
  /** @type {RequestInit & {headers: HeadersInit}} */
  const options = {
    method,
    credentials: 'include', // Include cookies in requests (for JWT)
    headers: {
      'Access-Control-Allow-Origin': '*',
      Accept: 'application/json',
    },
  }

  if (body instanceof FormData) {
    options.body = body
    // Don't set Content-Type for FormData, let the browser set it automatically
  } else if (body) {
    // @ts-ignore
    options.headers['Content-Type'] = contentType
    options.body = JSON.stringify(body)
  } else {
    // @ts-ignore
    options.headers['Content-Type'] = contentType
  }


  let res = await fetch(API + path, options)
  
  if (res.status === 401 && !path.includes('/authentication/')) {
    console.log('🔐 API: Got 401, attempting token refresh for:', path);
    try {
      // Attempt to refresh the token
      const refreshResponse = await refreshTokenV2()
      
      // @ts-ignore
      if ((refreshResponse.expiry && refreshResponse.refresh)) {
        console.log('🔐 API: Refresh successful, retrying original request');
        // Refresh succeeded, retry the original request once
        res = await fetch(API + path, options)
        // @ts-ignore
      } else if (refreshResponse.status === 401 || refreshResponse.status === 403) {
        console.log('🔐 API: Refresh failed with auth error, redirecting to login');
        // Refresh token is invalid or expired - kick to login
        clearSession()
        go(routes.LOGIN.path)
        // Return a rejected promise so the calling code knows what happened
        return Promise.reject(/** @type {HttpError} */ {
          message: 'Authentication failed. Please login again.',
          res: refreshResponse,
        })
      }
    } catch (error) {
      console.log('🔐 API: Error during refresh attempt:', error);
      // If it's an auth error from Promise.reject above, re-throw it
      if (error.message === 'Authentication failed. Please login again.') {
        throw error;
      }
      // Otherwise, let the original 401 response be handled below
    }
  }
  
  if (res.ok) {
    return res
  } else {
    let message = res.statusText
    try {
      const errorData = await res.json()
      message = errorData.message || res.statusText
    } catch {
      // Response wasn't JSON, use statusText
    }
    
    throw /** @type {HttpError} */ {
      message: message || res.statusText || 'Request failed',
      res,
    }
  }
}
